import React from "react";
import { CompareCourse } from "@modules/study/compare";
import { LayoutMain } from "@unisearch/theme/layout";

const CompareCourses = () => {
  let data = 3;
  return (
    <>
      <LayoutMain
        title="Compare Course"
        metaUrl={`${process.env.NEXT_PUBLIC_URL}/compare/course`}
      >
        <CompareCourse data={data} />
      </LayoutMain>
    </>
  );
};

export default CompareCourses;
